import React, {Component, ReactElement, ReactNode, RefObject} from 'react'
import NatMessageRepo from '../message/repository/NatMessageRepo'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {
    MessageFileList,
    MessageNotDeliveryCondominiumList,
    NatPutMessage,
    NatPutMessageParams,
} from './repository/NatPutMessage'
import {
    ADMINISTORATOR_MODE,
    AVAILABLE_OR_NOT,
    HAVE_OR_NOT,
    MESSAGE_CATEGORY,
    MESSAGE_CATEGORY_FOR_LEVEL4,
    MESSAGE_CATEGORY_FOR_MANAGEMENT_UNION,
    MESSAGE_TYPE,
    PREFECTURES_MASTER,
    ROLE_FOR_ADMINISTRATOR,
    SELECT_CONDOMINIUM_TYPE,
    SET_EXISTENCE,
    VALID_OR_NOT,
    VALID_OR_NOT_CHECK,
} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../app/TypeHelpers'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import {CurrentDateTime, NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {Messages} from '../../../Messages'
import {MessageNotDeliveryCondominium, NatGetMessage} from './repository/NatGetMessage'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink, StyledLink} from '../../../styledComponents/adminPage/Links'
import {
    InnerMiniTable,
    InnerMiniTableBody,
    InnerMiniTableCell,
    StyledTableCaption,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup'
import PPInput from '../../../components/shared/forms/PPInput'
import PPNumericField from '../../../components/shared/forms/PPNumericField'
import {getYearAfterNextDate, getYearDate, openPdfPreviewWindow} from '../../common/util/Natutil'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {
    FlexStartRowFlexContainer,
    LeftRowFlexContainer,
    RowFlexContainer,
} from '../../../styledComponents/FlexComponents'
import {StyledDiv, StyledLabel, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import NatCondominiumSelectionComponent from '../common/admin/NatCondominiumSelectionComponent'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import {
    BillingStatus,
    CondominiumInfo,
    NatGetCondominiumList,
    SearchCondition,
    SearchConditionPageInfo,
} from '../condominium/repository/NatGetCondominiumList'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import {formatForDateInput} from '../../../formatters/formatDate'
import {isIE} from 'react-device-detect'
import PPFileInput from '../../../components/shared/forms/PPFileInput'
import {NatCreatePreviewForResident} from '../common/admin/NatCreatePreviewForResident'
import NatMessageForResidentComponent from './common/NatMessageForResidentComponent'
import {Box, Dialog, Link, Table, TableBody, TableCell, TableRow} from '@mui/material'
import PPRadioGroup, {PPRadioItemProp} from '../../../components/shared/forms/PPRadioGroup'
import {SortOrder} from '../../../components/shared/SortOrder'
import NatDeliveryTargetAreaSelectionComponent from '../common/admin/NatDeliveryTargetAreaSelectionComponent'
import PPErrorLabel from '../../../components/shared/forms/PPErrorLabel'
import {FontWeights} from '../../../styledComponents/Constants'
import {SelectChangeEvent} from '@mui/material/Select'
import {NatDoNotifyNotice} from './common/NatAdminMessageComponent'
import {Location} from 'react-router-dom'
import ReactDOM from 'react-dom'

const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'
const SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'
const HINT_TEXT_DESCRIPTION = Messages.HNTFA0001.toString()
const HINT_TEXT_TOP_FIXED = Messages.HNTFA0002.toString()

const CreatePreviewForResident = NatCreatePreviewForResident({})(NatMessageForResidentComponent)

interface Props {
    condominiumRepo: NatCondominiumRepo
    messageId: string
    messageRepo: NatMessageRepo,
    condominiumGroupRepo: NatCondominiumGroupRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    condominiumGroup: NatGetCondominiumGroup
    messageEditParams: NatPutMessageParams
    selectedDeliveryTargetCondominiumInfo: CondominiumInfo[]
    deliveryTargetPrefectureCd: string
    deliveryTargetAddress2: string
    currentDateTime: CurrentDateTime
    publishStartDateMin: string
    publishStartDateMax: string
    publishEndDateMin: string
    publishEndDateMax: string
    messageFileList: CustomMessageFileList[]
    fileName: string
    publishMaterialName: string
    fileData: string | ArrayBuffer | null
    fileSize: number
    addMessageFileButtonDisabled: boolean
    isLoadCompleted: boolean
    loginUserRoleId: string | null
    dialogOpenSelectExcludeCondominium: boolean
    dialogOpenSelectDeliveryTargetArea: boolean
    selectedExcludeCondominiumInfo: MessageNotDeliveryCondominium[]
    selectCondominiumGroupId: number | null
    fileInputDisabled: boolean
    doNotifyDisabled: boolean
    notifiedFlag: string
    preview: boolean
    copyAvailability: string
}

interface CustomMessageFileList extends MessageFileList {
    registeredFlag: boolean
    deleteFlag: boolean
}

class NatAdminMessageEditPage extends Component<Props & AdminPagePropsSet, States> {

    messageFile: RefObject<HTMLInputElement>
    mode: Nullable<string>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.mode = SessionStorageHelper.getStringItemOrNull(SELECTED_ADMINISTORATOR_MODE)

        const loginUserRoleId: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)

        this.state = {
            condominiumGroup: {
                ['details']: null,
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            messageEditParams: {
                condominiumGroupId: 0,
                deliveryTargetPrefectureCd: '',
                deliveryTargetAddress2: '',
                messageNotDeliveryCondominium: [],
                categoryId: '',
                title: '',
                description: '',
                publishStartDate: '',
                publishEndDate: '',
                topFixed: '',
                messageFile: [],
                doNotify: '',
            },
            deliveryTargetPrefectureCd: '',
            deliveryTargetAddress2: '',
            selectedDeliveryTargetCondominiumInfo: [],
            currentDateTime: {
                currentDateTime: '',
                holidayFlag: '',
            },
            publishStartDateMin: '',
            publishStartDateMax: '',
            publishEndDateMin: '',
            publishEndDateMax: '',
            messageFileList: [],
            fileName: '',
            publishMaterialName: '',
            fileData: '',
            fileSize: 0,
            addMessageFileButtonDisabled: true,
            isLoadCompleted: false,
            loginUserRoleId: loginUserRoleId,
            dialogOpenSelectExcludeCondominium: false,
            dialogOpenSelectDeliveryTargetArea: false,
            selectedExcludeCondominiumInfo: [],
            selectCondominiumGroupId: null,
            fileInputDisabled: false,
            doNotifyDisabled: false,
            notifiedFlag: HAVE_OR_NOT.NOT.value,
            preview: false,
            copyAvailability: AVAILABLE_OR_NOT.AVAILABLE.value,
        }
        this.messageFile = React.createRef()

        this.setSelectedExclusionCondominiumInfo = this.setSelectedExclusionCondominiumInfo.bind(this)
        this.handleOpenExclusionCondominiumSelectionDialog =
            this.handleOpenExclusionCondominiumSelectionDialog.bind(this)
        this.closeSelectCondominiumDiaLog = this.closeSelectCondominiumDiaLog.bind(this)
        this.onChangeSelectedCondominiumGroupId = this.onChangeSelectedCondominiumGroupId.bind(this)
        this.changePublishEndDate = this.changePublishEndDate.bind(this)
        this.changePublishStartDate = this.changePublishStartDate.bind(this)
        this.changeDescription = this.changeDescription.bind(this)
        this.changeTitle = this.changeTitle.bind(this)
        this.changeTopFixed = this.changeTopFixed.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.changeCategoryId = this.changeCategoryId.bind(this)
        this.changePublishMaterialName = this.changePublishMaterialName.bind(this)
        this.changeFile = this.changeFile.bind(this)
        this.addMessageFile = this.addMessageFile.bind(this)
        this.changeMessageFileSortOrder = this.changeMessageFileSortOrder.bind(this)
        this.editMessageButton = this.editMessageButton.bind(this)
        this.changeMessagePublishName = this.changeMessagePublishName.bind(this)
        this.previewOpenButton = this.previewOpenButton.bind(this)
        this.previewCloseButton = this.previewCloseButton.bind(this)
        this.getCopyAvailabilityRadioGroupData = this.getCopyAvailabilityRadioGroupData.bind(this)
        this.changeCopyAvailability = this.changeCopyAvailability.bind(this)
        this.validMessageFileCount = this.validMessageFileCount.bind(this)
        this.handleOpenDeliveryTargetAreaSelectionDialog = this.handleOpenDeliveryTargetAreaSelectionDialog.bind(this)
        this.handleCloseDeliveryTargetAreaSelectionDialog =
            this.handleCloseDeliveryTargetAreaSelectionDialog.bind(this)
        this.setSelectedDeliveryTargetCondominiumInfo = this.setSelectedDeliveryTargetCondominiumInfo.bind(this)
        this.setDeliveryTargetPrefectureCd = this.setDeliveryTargetPrefectureCd.bind(this)
        this.setDeliveryTargetAddress2 = this.setDeliveryTargetAddress2.bind(this)
        this.changeDoNotify = this.changeDoNotify.bind(this)
        this.onClinkDoNotify = this.onClinkDoNotify.bind(this)
    }

    async componentDidMount(): Promise<void> {

        await this.props.eventEmitter.showLoading()
        try {
            // 全体モード時のみ物件グループを取得
            // 物件グループ
            if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
                const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                    this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (condominiumGroupResponse && condominiumGroupResponse.details) {
                    this.setState({condominiumGroup: condominiumGroupResponse})
                }
            }

            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            let maxDate: string = ''
            if (currentDateTime && currentDateTime.details) {
                // システム稼働年度頭
                const minDate: string = getYearDate()
                // システム日付の翌々年度末
                maxDate = getYearAfterNextDate(currentDateTime.details.currentDateTime)
                this.setState({
                    publishStartDateMin: minDate,
                    publishStartDateMax: maxDate,
                    publishEndDateMin: minDate,
                    publishEndDateMax: maxDate,
                    currentDateTime: currentDateTime.details,
                })
            }

            // メッセージ取得
            const getMessageResponse: Nullable<NatGetMessage> = await this.props.asyncCallFunction(
                this.props.messageRepo.getMessage.bind(this.props.messageRepo, this.props.messageId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (getMessageResponse && getMessageResponse.details) {
                const messageFileList: CustomMessageFileList[] = []
                if (getMessageResponse.details.messageFile) {
                    getMessageResponse.details.messageFile.forEach((file, index) => {
                        const messageFile: CustomMessageFileList = {
                            fileNumber: file.fileNumber,
                            sortOrder: file.sortOrder,
                            publishMaterialName: file.publishMaterialName,
                            fileName: file.fileName,
                            path: file.path,
                            registeredFlag: true,
                            deleteFlag: false,
                        }
                        messageFileList.push(messageFile)
                    })
                }

                const putMessageParamMessageNotDeliveryCondominium: MessageNotDeliveryCondominiumList[] = []
                getMessageResponse.details.messageNotDeliveryCondominium.map((condominiumInfo) => {
                    putMessageParamMessageNotDeliveryCondominium.push({condominiumCd: condominiumInfo.condominiumCd})
                })

                const messageEditParams: NatPutMessageParams = {
                    messageId: getMessageResponse.details.messageId,
                    condominiumGroupId: Number(getMessageResponse.details.condominiumGroupId),
                    messageNotDeliveryCondominium: putMessageParamMessageNotDeliveryCondominium,
                    categoryId: getMessageResponse.details.categoryId,
                    title: getMessageResponse.details.title,
                    description: getMessageResponse.details.description,
                    publishStartDate: getMessageResponse.details.publishStartDate,
                    publishEndDate: getMessageResponse.details.publishEndDate,
                    topFixed: getMessageResponse.details.topFixed,
                    copyAvailability: getMessageResponse.details.copyAvailability,
                    version: getMessageResponse.details.version,
                    messageFile: messageFileList,
                    doNotify: getMessageResponse.details.doNotify,
                }

                ReactDOM.flushSync(() => {
                    if (getMessageResponse && getMessageResponse.details) {
                        this.setState({
                            messageEditParams: messageEditParams,
                            deliveryTargetPrefectureCd: getMessageResponse.details.deliveryTargetPrefectureCd ?
                                getMessageResponse.details.deliveryTargetPrefectureCd : '',
                            deliveryTargetAddress2: getMessageResponse.details.deliveryTargetAddress2 ?
                                getMessageResponse.details.deliveryTargetAddress2 : '',
                            messageFileList: messageFileList,
                            publishStartDateMax: getMessageResponse.details.publishEndDate ?? maxDate,
                            publishEndDateMin: getMessageResponse.details.publishStartDate,
                            selectedExcludeCondominiumInfo: getMessageResponse.details.messageNotDeliveryCondominium,
                            selectCondominiumGroupId: getMessageResponse.details.condominiumGroupId,
                            fileInputDisabled: false,
                            notifiedFlag: getMessageResponse.details.notifiedFlag,
                        }, () => {
                            this.updateDoNotifyDisabled()
                        })
                    }
                })
                // 配信対象物件一覧の設定
                await this.getSelectedDeliveryTargetCondominiumInfo(
                    this.state.selectCondominiumGroupId,
                    this.state.deliveryTargetPrefectureCd,
                    this.state.deliveryTargetAddress2,
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    // 配信対象物件一覧の取得
    async getSelectedDeliveryTargetCondominiumInfo(
        condominiumGroupId: Nullable<number>,
        deliveryTargetPrefectureCd: Nullable<string>,
        deliveryTargetAddress2: Nullable<string>,
    ): Promise<void> {
        if (deliveryTargetPrefectureCd !== '' || deliveryTargetAddress2 !== '') {
            const billingStatus: BillingStatus = {
                billingDeadline: null,
                confirmStatus: null,
                targetYearMonth: null,
                electedTargetYearMonth: null,
            }
            const searchCondition: SearchCondition = {
                condominiumCd: null,
                condominiumName: null,
                condominiumGroupId: condominiumGroupId,
                prefectureCd: deliveryTargetPrefectureCd,
                address2: deliveryTargetAddress2,
                detailSearchCondition: null,
                billingStatus: billingStatus,
                unreleaseCondominiumExclusionFlg: null,
            }
            const searchConditionPageInfo: SearchConditionPageInfo = {
                pageNum: 0,
                page: 0,
            }
            const searchConditionSortInfo: SortOrder[] = [new SortOrder('condominiumCd', 'asc')]

            this.setState({
                selectedDeliveryTargetCondominiumInfo:
                    await this.searchCondominiums(
                        searchCondition,
                        searchConditionPageInfo,
                        searchConditionSortInfo),
            })
        }
    }

    // 物件一覧検索結果の取得
    async searchCondominiums(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfo: SortOrder[],
    ): Promise<CondominiumInfo[]> {
        const searchParams: string[] = []

        if (searchConditionSortInfo) {

            searchConditionSortInfo.forEach((sortInfo) => {
                const value: string = `${sortInfo.sortKey}:${sortInfo.sortDirection}`
                searchParams.push(`sortInfo=${value}`)
            })
        }

        // 物件一覧取得
        const getCondominiumResponse: Nullable<NatGetCondominiumList> =
            await this.props.asyncCallFunction(
                this.props.condominiumRepo.getCondominiumList.bind(
                    this.props.condominiumRepo,
                    {...searchCondition, ...searchConditionPageInfo, sortInfo: searchParams},
                ),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

        if (getCondominiumResponse) {
            if (getCondominiumResponse.details) {
                return getCondominiumResponse.details.condominiumInfo
            }
        }
        return []
    }


    onChangeSelectedCondominiumGroupId(condomoniumGroupId: number): void {
        const messageEditParams: NatPutMessageParams = this.state.messageEditParams
        messageEditParams.condominiumGroupId = condomoniumGroupId

        // 物件グループを変更する度に除外する物件をクリアする
        this.setState({selectedExcludeCondominiumInfo: []})
        messageEditParams.messageNotDeliveryCondominium = []

        this.setState({messageEditParams: messageEditParams, selectCondominiumGroupId: condomoniumGroupId})

    }

    changeCategoryId(event: SelectChangeEvent<unknown>): void {
        const messageEditParams: NatPutMessageParams = this.state.messageEditParams
        messageEditParams.categoryId = event.target.value as string
        this.setState({messageEditParams: messageEditParams},
            () => {
                this.updateDoNotifyDisabled()
            },
        )
    }

    changeTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        const messageEditParams: NatPutMessageParams = this.state.messageEditParams
        messageEditParams.title = event.target.value
        this.setState({messageEditParams: messageEditParams})
    }


    changeDescription(value: string): void {
        const messageEditParams: NatPutMessageParams = this.state.messageEditParams
        messageEditParams.description = value
        this.setState({messageEditParams: messageEditParams})
    }


    changePublishStartDate(date: Nullable<Date>): void {
        const messageEditParams: NatPutMessageParams = this.state.messageEditParams
        if (date !== null) {
            messageEditParams.publishStartDate = formatForDateInput(date.toString())
        } else {
            messageEditParams.publishStartDate = ''
        }
        this.setState({
            publishEndDateMin: date ? formatForDateInput(date.toString()) : getYearDate(),
            messageEditParams: messageEditParams,
        })
    }

    changePublishEndDate(date: Nullable<Date>): void {
        const messageEditParams: NatPutMessageParams = this.state.messageEditParams
        if (date !== null) {
            messageEditParams.publishEndDate = formatForDateInput(date.toString())
        } else {
            messageEditParams.publishEndDate = ''
        }
        this.setState({
            publishStartDateMax: date ? formatForDateInput(date.toString()) :
                getYearAfterNextDate(this.state.currentDateTime.currentDateTime),
            messageEditParams: messageEditParams,
        })
    }

    changeTopFixed(): void {
        const messageEditParams: NatPutMessageParams = this.state.messageEditParams
        if (this.state.messageEditParams.topFixed === VALID_OR_NOT_CHECK.VALID.value) {
            messageEditParams.topFixed = VALID_OR_NOT_CHECK.NOT.value
        } else {
            messageEditParams.topFixed = VALID_OR_NOT_CHECK.VALID.value
        }
        this.setState({messageEditParams: messageEditParams})
    }

    previewMessageFile(dataUri: string): void {
        const data: string[] = dataUri.split(',')
        if (data[1]) {
            openPdfPreviewWindow(data[1])
        }
    }

    changeFile(event: React.ChangeEvent<HTMLInputElement>): void {
        // ファイル情報取得
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {
            if (this.state.publishMaterialName) {
                this.setState({addMessageFileButtonDisabled: false})
            } else {
                this.setState({addMessageFileButtonDisabled: true})
            }
            this.setState({
                fileName: event.target.files[0].name,
                fileSize: event.target.files[0].size,
            })
            const reader: FileReader = new FileReader()
            reader.onload = () => {
                this.setState({fileData: reader.result})
            }
            reader.readAsDataURL(event.target.files[0])
        } else {
            this.setState({
                fileName: '',
                fileData: '',
                fileSize: 0,
                addMessageFileButtonDisabled: true,
            })
        }
    }

    changePublishMaterialName(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.value && this.state.fileName) {
            this.setState({addMessageFileButtonDisabled: false})
        } else {
            this.setState({addMessageFileButtonDisabled: true})
        }
        this.setState({publishMaterialName: event.target.value})
    }

    changeMessagePublishName(event: React.ChangeEvent<HTMLInputElement>): void {
        const messageFileList = this.state.messageFileList
        messageFileList[Number(event.target.name)].publishMaterialName = event.target.value
        this.setState({messageFileList: messageFileList})
    }

    changeMessageFileSortOrder(event: React.ChangeEvent<HTMLInputElement>): void {
        const messageFileList = this.state.messageFileList
        messageFileList[Number(event.target.name)].sortOrder = Number(event.target.value)
        this.setState({messageFileList: messageFileList})
    }

    validMessageFileCount(): number {
        const messageFileList = this.state.messageFileList
        const validMessageFileCount = messageFileList.filter(file => file.deleteFlag === false).length
        return validMessageFileCount
    }

    addMessageFile(): void {
        const messageFileList = this.state.messageFileList
        const validMessageFileList = messageFileList.filter(file => file.deleteFlag === false)
        const addFileList = validMessageFileList.filter(file => file.registeredFlag === false)
        const messageFile: CustomMessageFileList = {
            ['sortOrder']: validMessageFileList.length + 1,
            ['fileName']: this.state.fileName,
            ['fileSize']: this.state.fileSize,
            ['fileData']: this.state.fileData,
            ['publishMaterialName']: this.state.publishMaterialName,
            ['registeredFlag']: false,
            ['deleteFlag']: false,
        }
        messageFileList.push(messageFile)
        this.setState({
            fileName: '',
            fileSize: 0,
            fileData: '',
            publishMaterialName: '',
            addMessageFileButtonDisabled: true,
            messageFileList: messageFileList,
            fileInputDisabled: (addFileList.length + 1 >= 3),
        })
        // 追加したタイミングで選択したファイルをクリア
        if (this.messageFile.current && this.messageFile.current.value) {
            this.messageFile.current.value = ''
        }
    }

    handleOpenExclusionCondominiumSelectionDialog(): void {
        this.setState({
            dialogOpenSelectExcludeCondominium: true,
        })
    }

    handleOpenDeliveryTargetAreaSelectionDialog(): void {
        this.setState({
            dialogOpenSelectDeliveryTargetArea: true,
        })
    }

    handleCloseDeliveryTargetAreaSelectionDialog(): void {
        this.setState({dialogOpenSelectDeliveryTargetArea: false})
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            const prefecturesMaster = PREFECTURES_MASTER.codeToEnumConstants(prefectureCd)
            return prefecturesMaster.label
        } else {
            return ''
        }
    }

    async onClinkDoNotify(): Promise<void> {
        if (this.state.messageEditParams.doNotify === SET_EXISTENCE.SET.value) {
            return this.changeDoNotify(SET_EXISTENCE.NOT)
        }
        await this.props.eventEmitter.showDialog({
                title: '通知有無の設定確認',
                errorLevel: MESSAGE_TYPE.INFORMATION,
                message: <NatDoNotifyNotice/>,
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: '設定しない',
                        buttonHandler: () => {
                            this.changeDoNotify(SET_EXISTENCE.NOT)
                            this.props.eventEmitter.closeDialog()
                        },
                    },
                    {
                        isDefault: false,
                        buttonLabel: '設定する',
                        buttonHandler: () => {
                            this.changeDoNotify(SET_EXISTENCE.SET)
                            this.props.eventEmitter.closeDialog()
                        },
                    },
                ],
            },
        )
    }

    setSelectedDeliveryTargetCondominiumInfo(selectedDeliveryTargetCondominiumInfo: CondominiumInfo[]): void {
        selectedDeliveryTargetCondominiumInfo.sort((a, b) => Number(a.condominiumCd) - Number(b.condominiumCd))
        this.setState({
            selectedDeliveryTargetCondominiumInfo: selectedDeliveryTargetCondominiumInfo,
            dialogOpenSelectDeliveryTargetArea: false,
        })
    }

    setDeliveryTargetPrefectureCd(deliveryTargetPrefectureCd: string): void {
        this.setState({
            deliveryTargetPrefectureCd: deliveryTargetPrefectureCd,
        })
    }

    setDeliveryTargetAddress2(deliveryTargetAddress2: string): void {
        this.setState({
            deliveryTargetAddress2: deliveryTargetAddress2,
        })
    }

    deleteExcludeCondominium(condominiumCd: string): void {
        const selectedExcludeCondominiumInfo: MessageNotDeliveryCondominium[] = []
        this.state.selectedExcludeCondominiumInfo.map((condominiumInfo) => {
            if (condominiumInfo.condominiumCd !== condominiumCd) {
                selectedExcludeCondominiumInfo.push(condominiumInfo)
            }
        })
        const messageEditParams = this.state.messageEditParams
        messageEditParams.messageNotDeliveryCondominium = selectedExcludeCondominiumInfo
        this.setState({
            selectedExcludeCondominiumInfo: selectedExcludeCondominiumInfo,
            messageEditParams: messageEditParams,
        })
    }

    deleteMessageFile(index: number): void {
        const messageFileList = this.state.messageFileList
        messageFileList[index].deleteFlag = true
        messageFileList[index].fileData = null
        const addFileCount = messageFileList.filter(file => file.registeredFlag === false
            && file.deleteFlag === false)
        this.setState({
            messageFileList: messageFileList,
            fileInputDisabled: (addFileCount.length >= 3),
        })
    }

    changeDoNotify(doNotify: SET_EXISTENCE): void {
        const messageEditParams = this.state.messageEditParams
        messageEditParams.doNotify = doNotify.value
        this.setState({messageEditParams: messageEditParams})
    }

    closeSelectCondominiumDiaLog(): void {
        this.setState({dialogOpenSelectExcludeCondominium: false})
    }

    judgEditMessageButton(): boolean {
        if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
            if (!this.state.messageEditParams.condominiumGroupId) {
                return true
            }
        }
        return !(this.state.messageEditParams.categoryId &&
            this.state.messageEditParams.title &&
            this.state.messageEditParams.description &&
            this.state.messageEditParams.publishStartDate)
    }

    getCopyAvailabilityRadioGroupData(): PPRadioItemProp[] {
        const CopyAvailabilityRadioGroupData: PPRadioItemProp[] = []
        AVAILABLE_OR_NOT.values().map((copyAvailability) => (
            CopyAvailabilityRadioGroupData.push(
                {
                    label: copyAvailability.label,
                    value: copyAvailability.value,
                    radioProps: {
                        checked: copyAvailability.value === this.state.messageEditParams.copyAvailability,
                        onChange: this.changeCopyAvailability,
                    },
                },
            )
        ))
        return CopyAvailabilityRadioGroupData
    }

    changeCopyAvailability(event: React.ChangeEvent<HTMLInputElement>): void {
        const messageEditParams: NatPutMessageParams = this.state.messageEditParams
        messageEditParams.copyAvailability = event.target.value as string
        this.setState({messageEditParams: messageEditParams})
        this.setState({copyAvailability: event.target.value})
    }

    setSelectedExclusionCondominiumInfo(selectedExcludeCondominiumInfo: CondominiumInfo[]): void {
        selectedExcludeCondominiumInfo.sort((a, b) => Number(a.condominiumCd) - Number(b.condominiumCd))
        const messageEditParams = this.state.messageEditParams
        messageEditParams.messageNotDeliveryCondominium = selectedExcludeCondominiumInfo
        this.setState({
            selectedExcludeCondominiumInfo: selectedExcludeCondominiumInfo,
            dialogOpenSelectExcludeCondominium: false,
            messageEditParams: messageEditParams,
        })
    }

    async editMessageButton(): Promise<void> {

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('メッセージ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )

    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {
            const messageEditParams = this.state.messageEditParams
            if (this.state.deliveryTargetAddress2) {
                messageEditParams.deliveryTargetAddress2 = this.state.deliveryTargetAddress2
            }
            if (this.state.deliveryTargetPrefectureCd) {
                messageEditParams.deliveryTargetPrefectureCd = this.state.deliveryTargetPrefectureCd
            }
            if (this.state.messageFileList) {
                const messageFileList: MessageFileList[] = []
                this.state.messageFileList.forEach((file, index) => {
                    const fileData: string[] = String(file.fileData).split(',')
                    if (file.deleteFlag === true) {
                        return
                    }
                    if (fileData[1]) {
                        let messageFile: MessageFileList
                        if (file.fileNumber) {
                            messageFile = {
                                fileNumber: file.fileNumber,
                                sortOrder: file.sortOrder,
                                publishMaterialName: file.publishMaterialName,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            }
                        } else {
                            messageFile = {
                                sortOrder: file.sortOrder,
                                publishMaterialName: file.publishMaterialName,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            }
                        }
                        messageFileList.push(messageFile)
                    } else {
                        messageFileList.push(file)
                    }
                })
                messageEditParams.messageFile = messageFileList
            }

            const registerMessageResponse: Nullable<NatPutMessage> = await this.props.asyncCallFunction(
                this.props.messageRepo.putMessage.bind(this.props.messageRepo, messageEditParams),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0002.toString('メッセージ')},
            )
            if (registerMessageResponse && registerMessageResponse.requestError === null) {
                this.props.navigate(`/admin/message/${this.props.messageId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0005.toString(
                                    'メッセージ', messageEditParams.title ? messageEditParams.title : '',
                                ),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    previewOpenButton(): void {
        this.setState({preview: true})
    }

    previewCloseButton(): void {
        this.setState({preview: false})
    }

    updateDoNotifyDisabled(): void {
        const {messageEditParams, notifiedFlag} = this.state

        let doNotifyDisabled = false
        if (notifiedFlag === HAVE_OR_NOT.HAVE.value) {
            doNotifyDisabled = true
        } else if (messageEditParams.categoryId === MESSAGE_CATEGORY.MANAGEMENT_COMPANY_PR.value) {
            doNotifyDisabled = true
            messageEditParams.doNotify = SET_EXISTENCE.NOT.value
        }

        this.setState({
            messageEditParams: messageEditParams,
            doNotifyDisabled: doNotifyDisabled,
        })
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                    {this.renderMessagePreviewDialog()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }


    renderInputFormTable(): ReactNode {
        return (
            <>
                <Table>
                    <StyledTableCaption>メッセージ情報</StyledTableCaption>
                    <TableBody>
                        {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                            <>
                                <TableRow>
                                    {this.state.condominiumGroup && this.state.condominiumGroup.details &&
                                        <>
                                            <TableRowName required>掲載範囲</TableRowName>
                                            <TableRowName>物件グループ</TableRowName>
                                            <TableCell colSpan={4}>
                                                <NatCondominiumGroupSelectComponent
                                                    condominiumGroup={this.state.condominiumGroup.details}
                                                    defaultValue={this.state.messageEditParams.condominiumGroupId ?
                                                        this.state.messageEditParams.condominiumGroupId : null}
                                                    onChangeSelectedCondominiumGroupId=
                                                        {this.onChangeSelectedCondominiumGroupId}
                                                    requiredFlag={true}
                                                    eventKeys={['condominiumGroupId']}
                                                    eventEmitter={this.props.eventEmitter}
                                                    autoFocus={true}
                                                >
                                                </NatCondominiumGroupSelectComponent>
                                            </TableCell>
                                        </>
                                    }
                                </TableRow>
                                {this.renderDeliveryTargetArea()}
                                {this.state.messageEditParams.messageNotDeliveryCondominium &&
                                    <>
                                        <TableRow>
                                            <TableRowName
                                                rowSpan={this.state.selectedExcludeCondominiumInfo.length + 1}>
                                                除外する物件を選択
                                            </TableRowName>
                                            <TableCell colSpan={4}>
                                                <AdminDefaultMediumButton
                                                    onClick={this.handleOpenExclusionCondominiumSelectionDialog}
                                                    size={'small'}
                                                >
                                                    物件を選択
                                                </AdminDefaultMediumButton>
                                            </TableCell>
                                        </TableRow>
                                        {this.state.dialogOpenSelectExcludeCondominium &&
                                            this.state.condominiumGroup.details &&
                                            <NatCondominiumSelectionComponent
                                                selectCondominiumType={SELECT_CONDOMINIUM_TYPE.EXCLUDE_CONDOMINIUM.value}
                                                condominiumRepo={this.props.condominiumRepo}
                                                condominiumGroupRepo={this.props.condominiumGroupRepo}
                                                closeSelectCondominiumDiaLog={this.closeSelectCondominiumDiaLog}
                                                setSelectedExclusionCondominiumInfo={this.setSelectedExclusionCondominiumInfo}
                                                eventEmitter={this.props.eventEmitter}
                                                selectedCondominiumGroupId={this.state.selectCondominiumGroupId}
                                                navigate={this.props.navigate}
                                                location={this.props.location}
                                                asyncCallFunction={this.props.asyncCallFunction}
                                                excludeCondominium={this.state.selectedExcludeCondominiumInfo}
                                            />
                                        }
                                        {this.state.selectedExcludeCondominiumInfo.length > 0 &&
                                            this.state.selectedExcludeCondominiumInfo.map((condominiumInfo, index) => {
                                                return (
                                                    <TableRow>
                                                        <TableCell colSpan={4}>
                                                            <LeftRowFlexContainer>
                                                                <SelectedNotDeliveryCondominium>
                                                                    <PPInput
                                                                        type="label"
                                                                        value={condominiumInfo.condominiumCd +
                                                                            ' ' + condominiumInfo.condominiumName}
                                                                        eventKeys={
                                                                            // tslint:disable-next-line:max-line-length
                                                                            [`messageNotDeliveryCondominium[${index}].condominiumCd`]
                                                                        }
                                                                        eventEmitter={this.props.eventEmitter}
                                                                    />
                                                                </SelectedNotDeliveryCondominium>
                                                                <SelectedNotDeliveryCondominium>
                                                                    <DeleteLink onClick={(event: React.MouseEvent) => {
                                                                        event.preventDefault()
                                                                        this.deleteExcludeCondominium(
                                                                            condominiumInfo.condominiumCd,
                                                                        )
                                                                    }}>
                                                                        削除
                                                                    </DeleteLink>
                                                                </SelectedNotDeliveryCondominium>
                                                            </LeftRowFlexContainer>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </>
                                }

                            </>
                        }
                        <TableRow>
                            <TableRowName required>カテゴリ</TableRowName>
                            <TableCell colSpan={4}>
                                <PPSelect
                                    defaultValue={this.state.messageEditParams.categoryId}
                                    data={this.getCategoryList()}
                                    onChange={this.changeCategoryId}
                                    eventKeys={['categoryId']}
                                    eventEmitter={this.props.eventEmitter}
                                    autoFocus={(this.mode === ADMINISTORATOR_MODE.ALL.value) ?
                                        false : true}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>タイトル</TableRowName>
                            <TableCell colSpan={4}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 50,
                                        },
                                    }}
                                    required
                                    fullWidth
                                    onChange={this.changeTitle}
                                    value={this.state.messageEditParams.title}
                                    eventKeys={['title']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required hint={Messages.HNTFA0001.toString()}>
                                本文
                            </TableRowName>
                            <TableCell colSpan={4}>
                                <PPHtmlEditor
                                    onEditorChange={this.changeDescription}
                                    value={this.state.messageEditParams.description}
                                    eventKeys={['description']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName required>掲載開始日</TableRowName>
                            <TableCell colSpan={4}>
                                <LeftRowFlexContainer>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4.5, paddingTop: 7.7}}>
                                            <PPDatePicker
                                                onChangeDate={this.changePublishStartDate}
                                                value={(this.state.messageEditParams.publishStartDate) ?
                                                    new Date(this.state.messageEditParams.publishStartDate) : null
                                                }
                                                minDate={(this.state.publishStartDateMin !== '') ?
                                                    new Date(this.state.publishStartDateMin) : undefined
                                                }
                                                maxDate={(this.state.publishStartDateMax) ?
                                                    new Date(this.state.publishStartDateMax) : undefined
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['publishStartDate']}
                                            />
                                        </FlexBasis>
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>掲載終了日</TableRowName>
                            <TableCell colSpan={4}>
                                <LeftRowFlexContainer>
                                    <TermWrapper>
                                        <FlexBasis style={{paddingBottom: 4.5, paddingTop: 7.7}}>
                                            <PPDatePicker
                                                onChangeDate={this.changePublishEndDate}
                                                value={(this.state.messageEditParams.publishEndDate) ?
                                                    new Date(this.state.messageEditParams.publishEndDate) : null
                                                }
                                                minDate={(this.state.publishEndDateMin !== '') ?
                                                    new Date(this.state.publishEndDateMin) : undefined
                                                }
                                                maxDate={(this.state.publishEndDateMax !== '') ?
                                                    new Date(this.state.publishEndDateMax) : undefined
                                                }
                                                eventEmitter={this.props.eventEmitter}
                                                eventKeys={['publishEndDate']}
                                            />
                                        </FlexBasis>
                                    </TermWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        {this.mode === ADMINISTORATOR_MODE.CONDOMINIUM.value &&
                            <>
                                <TableRow>
                                    <TableRowName hint={Messages.HNTFA0002.toString()}>
                                        上位固定
                                    </TableRowName>
                                    <TableCell colSpan={4}>
                                        <PPCheckboxGroup
                                            data={[{
                                                label: '上位固定する（最大2件まで）',
                                                checked: VALID_OR_NOT.VALID.value === this.state.messageEditParams.topFixed,
                                            }]}
                                            onChangeChecked={this.changeTopFixed}
                                            eventKeys={['topFixed']}
                                            eventEmitter={this.props.eventEmitter}
                                            hint={HINT_TEXT_TOP_FIXED}
                                        />
                                    </TableCell>
                                </TableRow>
                            </>
                        }

                        {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                            <>
                                <TableRow>
                                    <TableRowName required>コピー可否</TableRowName>
                                    <TableCell colSpan={4}>
                                        <PPRadioGroup
                                            row
                                            data={this.getCopyAvailabilityRadioGroupData()}
                                            eventKeys={['copyAvailability']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </TableCell>
                                </TableRow>
                            </>
                        }
                        <TableRow>
                            <TableRowName
                                {...{
                                    rowSpan: this.validMessageFileCount() !== 0 ?
                                        this.validMessageFileCount() + 1 : 1,
                                }}
                            >掲載資料</TableRowName>
                            <TableCell colSpan={4}>
                                <FlexStartRowFlexContainer>
                                    <DocumentNameWrapper>
                                        <TableCellLabelNoLeftPadding>掲載資料名</TableCellLabelNoLeftPadding>
                                        <PPTextField
                                            InputProps={{
                                                inputProps: {
                                                    id: 'publishMaterialName',
                                                    maxLength: 50,
                                                },
                                            }}
                                            required
                                            fullWidth
                                            onChange={this.changePublishMaterialName}
                                            eventKeys={['publishMaterialName']}
                                            value={this.state.publishMaterialName}
                                            eventEmitter={this.props.eventEmitter}
                                            disabled={this.state.fileInputDisabled}
                                        />
                                    </DocumentNameWrapper>
                                    <DocumentWrapper>
                                        <DocumentFormWrapper>
                                            <PPFileInput
                                                InputProps={{
                                                    inputProps: {
                                                        id: 'messageFile',
                                                        name: 'messageFile',
                                                    },
                                                }}
                                                fullWidth
                                                inputRef={this.messageFile}
                                                onChange={this.changeFile}
                                                fileName={this.state.fileName}
                                                eventKeys={['messageFile']}
                                                eventEmitter={this.props.eventEmitter}
                                                disabled={this.state.fileInputDisabled}
                                            />
                                        </DocumentFormWrapper>
                                        <div style={{color: 'red', flex: '1 0 auto'}}>※5MBまで</div>
                                    </DocumentWrapper>
                                    <DocumentAddButtonWrapper>
                                        <AdminPrimaryButton
                                            onClick={this.addMessageFile}
                                            disabled={this.state.addMessageFileButtonDisabled
                                                || this.state.fileInputDisabled}
                                        >PDFを追加
                                        </AdminPrimaryButton>
                                    </DocumentAddButtonWrapper>
                                </FlexStartRowFlexContainer>
                            </TableCell>
                        </TableRow>
                        {this.renderFileArea()}
                        <TableRow>
                            <TableRowName hint={Messages.HNTFA0004.toString()}>
                                通知有無
                            </TableRowName>
                            <TableCell colSpan={4}>
                                <PPCheckboxGroup
                                    data={
                                        [{
                                            label: '居住者に通知する',
                                            checked: this.state.messageEditParams.doNotify === SET_EXISTENCE.SET.value,
                                            checkboxProps: {disabled: this.state.doNotifyDisabled},
                                        }]
                                    }
                                    onChangeChecked={this.onClinkDoNotify}
                                    eventKeys={['doNotify']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        )
    }

    renderFileArea(): ReactNode {
        return <>{this.state.messageFileList.map((messageFile, index) => (
            (messageFile.deleteFlag === false) ?
                <TableRow key={index}>
                    <TableCell colSpan={4}>
                        <RowFlexContainer>
                            <AlreadyDocumentWrapper>
                                <TableCellLabelNoLeftPadding>
                                    {(messageFile.fileData) ?
                                        <a href="javascript:void(0)"
                                           onClick={(event: React.MouseEvent<HTMLElement>) => {
                                               event.preventDefault()
                                               this.previewMessageFile(messageFile.fileData as string)
                                           }}>
                                            <img
                                                src={
                                                    `/resources/images/icons/icon_pdf.png`
                                                }
                                                alt=""/>
                                        </a> : (isIE) ?
                                            <Link
                                                onClick={() => window.open(messageFile.path)}
                                                target={'_blank'}
                                                underline="hover">
                                                <img
                                                    src={
                                                        `/resources/images/icons/icon_pdf.png`
                                                    }
                                                    alt=""
                                                />
                                            </Link> :
                                            <Link href={messageFile.path} target={'_blank'} underline="hover">
                                                <img
                                                    src={
                                                        `/resources/images/icons/icon_pdf.png`
                                                    }
                                                    alt=""
                                                />
                                            </Link>

                                    }
                                </TableCellLabelNoLeftPadding>
                                <PPInput
                                    type="text"
                                    inputProps={{
                                        maxLength: 50,
                                    }}
                                    name={String(index)}
                                    value={messageFile.publishMaterialName}
                                    onChange={this.changeMessagePublishName.bind(this)}
                                    eventKeys={[`messageFile[${index}].publishMaterialName`]}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </AlreadyDocumentWrapper>
                            <TableCellLabelNoLeftPadding>
                                並び順
                            </TableCellLabelNoLeftPadding>
                            <OrderWrapper>
                                <DocumentFormWrapper>
                                    <PPNumericField
                                        InputProps={{
                                            inputProps: {
                                                min: 1,
                                                max: 999,
                                            },
                                        }}
                                        fullWidth
                                        name={String(index)}
                                        onChange={this.changeMessageFileSortOrder}
                                        value={messageFile.sortOrder}
                                        eventKeys={[`messageFile[${index}].sortOrder`]}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </DocumentFormWrapper>
                            </OrderWrapper>
                            <AlreadyDocumentWrapper>
                                <TableCellLabelNoLeftPadding>
                                    <StyledLink onClick={() => this.deleteMessageFile(index)}>
                                        削除
                                    </StyledLink>
                                </TableCellLabelNoLeftPadding>
                            </AlreadyDocumentWrapper>
                        </RowFlexContainer>
                    </TableCell>
                </TableRow>
                : null
        ))}
        </>
    }

    renderDeliveryTargetArea(): ReactNode {

        return (
            <>
                <TableRow>
                    <TableRowName>
                        配信対象を地域から選択
                    </TableRowName>
                    <TableCell colSpan={3}>
                        <LeftRowFlexContainer>
                            <AdminDefaultMediumButton
                                onClick={this.handleOpenDeliveryTargetAreaSelectionDialog}
                                size={'small'}
                            >
                                地域を選択
                            </AdminDefaultMediumButton>
                            {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== ''
                                ? <DeliveryTargetArea>
                                    <DeliveryTargetAreaTxt>
                                        {` 指定地域: `
                                            + this.getPrefectureName(this.state.deliveryTargetPrefectureCd)
                                            + this.state.deliveryTargetAddress2
                                        }
                                    </DeliveryTargetAreaTxt>
                                </DeliveryTargetArea>
                                : ``
                            }
                            {this.state.deliveryTargetPrefectureCd !== '' || this.state.deliveryTargetAddress2 !== ''
                                ? <DeleteLink onClick={(event: React.MouseEvent) => {
                                    event.preventDefault()
                                    this.setState({
                                        deliveryTargetPrefectureCd: '',
                                        deliveryTargetAddress2: '',
                                        selectedDeliveryTargetCondominiumInfo: [],
                                    })
                                }}>
                                    削除
                                </DeleteLink>
                                : ''
                            }
                        </LeftRowFlexContainer>
                        {this.state.dialogOpenSelectDeliveryTargetArea && this.state.condominiumGroup.details &&
                            <NatDeliveryTargetAreaSelectionComponent
                                condominiumRepo={this.props.condominiumRepo}
                                condominiumGroupRepo={this.props.condominiumGroupRepo}
                                closeSelectDeliveryTargetAreaDiaLog=
                                    {this.handleCloseDeliveryTargetAreaSelectionDialog}
                                setSelectedDeliveryTargetCondominiumInfo=
                                    {this.setSelectedDeliveryTargetCondominiumInfo}
                                setDeliveryTargetPrefectureCd={this.setDeliveryTargetPrefectureCd}
                                setDeliveryTargetAddress2={this.setDeliveryTargetAddress2}
                                eventEmitter={this.props.eventEmitter}
                                selectedCondominiumGroupId={this.state.selectCondominiumGroupId}
                                navigate={this.props.navigate}
                                location={this.props.location}
                                asyncCallFunction={this.props.asyncCallFunction}
                            />
                        }
                        {
                            <InnerMiniTable>
                                <InnerMiniTableBody>
                                    {this.state.selectedDeliveryTargetCondominiumInfo.map(
                                        (condominiumInfo, index) => {
                                            return (
                                                <TableRow key={condominiumInfo.condominiumCd}>
                                                    <InnerMiniTableCell>
                                                        {condominiumInfo.condominiumCd + ' ' +
                                                            condominiumInfo.condominiumName}
                                                        <PPErrorLabel
                                                            eventEmitter={this.props.eventEmitter}
                                                            eventKeys={[`messageDeliveryTargetCondominium
                                                            [${index}].condominiumCd`]}
                                                        />
                                                    </InnerMiniTableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </InnerMiniTableBody>
                            </InnerMiniTable>
                        }
                    </TableCell>
                </TableRow>
            </>
        )
    }

    getCategoryList(): OptionProps[] {
        let categories: OptionProps[] = []

        if (this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value ||
            this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.CALL_CENTER.value ||
            this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.FRONT_STAFF.value
        ) {
            categories = MESSAGE_CATEGORY.values().map((messageCategory) => {
                return ({
                    label: `${messageCategory.label}`,
                    value: `${messageCategory.value}`,
                })
            })
        }

        if (this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.LIFE_MANAGER.value ||
            this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.CONCIERGE.value
        ) {
            categories = MESSAGE_CATEGORY_FOR_LEVEL4.values().map((messageCategory) => {
                return ({
                    label: `${messageCategory.label}`,
                    value: `${messageCategory.value}`,
                })
            })
        }

        if (this.state.loginUserRoleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value
        ) {
            categories = MESSAGE_CATEGORY_FOR_MANAGEMENT_UNION.values().map((messageCategory) => {
                return ({
                    label: `${messageCategory.label}`,
                    value: `${messageCategory.value}`,
                })
            })
        }


        return [{
            label: 'カテゴリを選択してください',
            value: '',
        }, ...categories]
    }


    renderMessagePreviewDialog(): ReactNode {
        return (
            <Dialog
                id={'pp-dialog'}
                open={this.state.preview}
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                maxWidth={'xs'}
            >
                <CreatePreviewForResident
                    {...this.props}
                    categoryId={this.state.messageEditParams.categoryId}
                    publishStartDate={this.state.messageEditParams.publishStartDate}
                    title={this.state.messageEditParams.title}
                    description={this.state.messageEditParams.description}
                    messageFile={this.state.messageFileList}
                    onClose={this.previewCloseButton}
                />
            </Dialog>
        )
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <Box pr={'15px'}>
                        <AdminPrimaryButton
                            disabled={this.judgEditMessageButton()}
                            onClick={this.previewOpenButton}
                        >
                            メッセージプレビュー
                        </AdminPrimaryButton>
                    </Box>
                    <AdminPrimaryButton
                        disabled={this.judgEditMessageButton()}
                        onClick={this.editMessageButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/message/${this.props.messageId}`,
                        )}
                    >
                        メッセージ詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }
}

const DeliveryTargetAreaTxt: StyledSpan = styled.span`
    font-weight: ${FontWeights.Bold};
`
const DeliveryTargetArea: StyledLabel = styled.label`
    white-space: nowrap;
    padding-left: 15px;
    padding-right: 15px;

    & .MuiInput-underline:before {
        border-bottom: none;
    }

    & .MuiInput-underline.Mui-error:after {
        border-bottom: none;
    }
`
const SelectedNotDeliveryCondominium: StyledLabel = styled.label`
    white-space: nowrap;
    padding-left: 15px;
    padding-right: 15px;

    & .MuiInput-underline:before {
        border-bottom: none;
    }

    & .MuiInput-underline.Mui-error:after {
        border-bottom: none;
    }
`

const TermWrapper: StyledDiv = styled.div`
    display: flex;
    flex: 1 1 auto;
    justify-items: center;
    align-items: center;
    max-width: 35%;
`

const TermTxt: StyledSpan = styled.span`
    padding: 0 5px 0 5px;
`

const DocumentNameWrapper: StyledDiv = styled.div`
    display: flex;
    flex: 1 1 auto;
    align-items: flex-end;
    padding-right: 15px;
`

const DocumentWrapper = styled(DocumentNameWrapper)`
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding-right: 15px;
    max-width: 40%;
`

const AlreadyDocumentWrapper = styled(DocumentNameWrapper)`
    flex: 1 1 0%;
    align-items: center;
`

const OrderWrapper = styled(AlreadyDocumentWrapper)`
    max-width: 10%;
`

const DocumentFormWrapper: StyledDiv = styled.div`
    flex: 1 0 auto;
    width: 100%;
`

const DocumentAddButtonWrapper: StyledDiv = styled.div`
    flex: 0 0 auto;
`

const TableCellLabelNoLeftPadding: StyledLabel = styled.label`
    padding: 0 10px 0 0;
`

const FlexBasis: StyledDiv = styled.div`
    flex: 1 1 0%;
`

export default createAdminPage(NatAdminMessageEditPage)

